
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.092 4.195l.5-.51c.614-.614.57-1.651-.043-2.266l-.322-.322c-.614-.615-1.65-.658-2.264-.044l-.51.501 2.639 2.642zM1.911 10.122l-.021.021L.31 14.21c-.04.1.06.2.165.166l4.053-1.59 8.168-8.176-2.643-2.645-8.146 8.154.004.004zm-.696 2.51l.8-2.048c.027.104.079.2.157.279.13.13.318.196.531.174l.118-.013-.013.118c-.018.209.043.4.178.536a.633.633 0 00.532.174l.117-.013-.013.117a.641.641 0 00.174.532.65.65 0 00.305.165l-2.06.807-.826-.828zm9.108-8.454l.117.117-6.195 6.202-.118-.118 6.196-6.201z"}})])
          )
        }
      }
    